import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../test-utils/utils/unidriver';

export const iconAffixDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    hasChild: (selector: string) => !!base.$(selector),
  };
};
